export const version = "networks/5.4.2";
//# sourceMappingURL=_version.js.map